import React, { Component } from 'react';
import _ from 'underscore';
import moment from 'moment';
import ga from 'analytics';

import Utils from 'utils/Utils.js';
import DateUtils from 'utils/DateUtils.js';

import ChallengeQuestionDate from './ChallengeQuestionDate.js';


class ChallengeQuestionDateContainer extends Component {
    constructor(props) {
        super(props);
        this.initialState = {};
        this.state = this.initialState;
        this.onChange = this.onChange.bind(this);
        this.onChangeDateText = this.onChangeDateText.bind(this);
    }
    componentWillMount() {
    }
    onChange(date) {
        console.log('SurveyPageDateContainer.onChange', date);
        this.props.onChange({target:{name:'selectedChallenge.challengeQuestions.' + this.props.index + '.data', 
                            value:date}});
    }
    onChangeDateText(event) {
    }
    render() {
        const value = Boolean(this.props.challengeQuestion && this.props.challengeQuestion.data) ? this.props.challengeQuestion.data.format(DateUtils.formatDisplay) : '';
        return <ChallengeQuestionDate
                   {...this.props}
                   value={value}
                   onChange={this.onChange}
                   onChangeDateText={this.onChangeDateText}
                   valid={this.state.valid && this.state.validDateText}
                   format={DateUtils.formatDisplay}
                   />;
    }

}

export default ChallengeQuestionDateContainer;



// WEBPACK FOOTER //
// ./src/modules/logs/ChallengeQuestionDateContainer.js